<template>
  <div>
    <div class=" row mb-2">
      <label class="col-sm-4  text-lr lh35"><i
          v-if=" Data.data.c_priority==='S'"
          class="fa fa-asterisk text-danger font10 ml-1"
          aria-hidden="true"></i>{{ Data.data.c_name }}：</label>
      <div class="col-sm-7 ">
        <!-- <div style="display: flex; "> -->

          <!-- <viewer :images="dialogImageUrl">
          </viewer> -->
          <div style="display: flex; gap: 3px; flex-wrap: wrap;">
            <div v-for="(file, index) in fileList" class="viewer-container" :key="index">
              <el-image :src="file.src" fit="scale-down" :preview-src-list="fileList.map(i => i.src)" />
              <el-button type="danger" icon="el-icon-delete" size="mini" @click="handleRemove(file, fileList)" />
            </div>
            <el-upload 
              class="upload-demo" 
              list-type="picture-card"
              ref="upload" 
              :action='IBMS_API+"IBMS/Public/UploadAttachment"'
              :headers="uploadHeaders" 
              :auto-upload="true"
              :file-list="fileList"
              accept='.jpg, .jpeg, .png, .gif'
              :http-request="changeFile"
              :on-remove="handleRemove"
              :show-file-list="false"
              v-loading="loading"
              :disabled="Data.attr.disabled===undefined?false:Data.attr.disabled"
              :on-preview="handlePictureCardPreview"
            >
              <el-button slot="trigger" size="small" type="primary"  :disabled="Data.attr.disabled===undefined?false:Data.attr.disabled">选取图片</el-button>
            </el-upload>
          </div>
          <!-- <el-dialog :visible.sync="dialogVisible" :append-to-body="true"> -->
            <!-- <img :src="dialogImageUrl" alt=""> -->
          <!-- </el-dialog> -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import { Image } from 'element-ui'

export default {
  name: "imgs",
  props: [
    'Data'
  ],
  components: {
    "el-image": Image
  },
  data() {
    return {
      limit: this.Data.attr.limit === undefined ? 9 : this.Data.attr.limit,
      dialogImageUrl: [],
      dialogVisible: false,
      formLabelWidth: '200px',
      fileList:[],
      loading: false,
      uploadHeaders:{
        "Authorization":`${store.state.auth_key}`,
        "x-csrftoken":'WEB',
        "content-type":"multipart/form-data"
      },
      postData: new FormData()
    };
  },

  created() {
    this.handle_file(this.Data)
    this.dialogImageUrl = this.fileList.map(i => i.src)
  },

  methods: {
    //自动上传
    changeFile (file) {
      this.loading = true
      let fd = new FormData()
      fd.append('file', file.file)// 传文件
      fd.append('upload_type', '上传')
      fd.append('sign', this.fileList.length ? this.fileList[0].object_id : "")
      fetch(this.IBMS_API+"IBMS/Public/UploadAttachment", {//fetces6语法，同axios/ajax作用
        method: 'POST',
        headers: {
          "Authorization": `${store.state.auth_key}`,
          "x-csrftoken": 'WEB'
        },
        body: fd//不为data为body否则报错
      })
      .then(res => res.json())
      .then(res => {
        this.loading = false
        if (res.result === 200) {
          this.fileList = res.content
          this.dialogImageUrl = this.fileList.map(i => i.src)
          this.$get_function(this.Data, this.fileList)
        }else{
          this.$message({
            message: '上传失败',
            type: 'error'
          });
        }
      })
    },

    handleRemove(file) {
      this.loading = true
      let fd = new FormData()
      fd.append('file', '')// 传文件
      fd.append('upload_type', '删除')
      fd.append('sign', this.fileList.length ? this.fileList[0].object_id : "")
      fd.append('delete_src', file.src)
      fetch(this.IBMS_API+"IBMS/Public/UploadAttachment", {//fetces6语法，同axios/ajax作用
        method: 'POST',
        headers: {
          "Authorization": `${store.state.auth_key}`,
          "x-csrftoken": 'WEB'
        },
        body: fd//不为data为body否则报错
      })
          .then(res => res.json())
          .then(() => {
            this.loading = false
            this.fileList = this.fileList.filter(i => i.uid !== file.uid)
            this.dialogImageUrl = this.fileList.map(i => i.src)
            this.$get_function(this.Data, this.fileList)
          })

    },

    handle_file(Data){
      this.fileList=[]
      this.dialogImageUrl = []
      for(let i in Data.data.c_value){
        this.fileList.push(Data.data.c_value[i])
      }
      this.dialogImageUrl = this.fileList.map(i => i.src)
    },

    jobOnChange(file,file_list){
      if(file.status==='ready'){
        this.fileList=file_list
      }
      this.dialogImageUrl = this.fileList.map(i => i.src)
    },

    submitUpload() {
      this.loading = true
      this.fileList.forEach(item => {
        this.postData.append('file', item.raw)
      })
      this.$axios({
        method: 'post',
        url: this.IBMS_API + 'IBMS/Public/UploadAttachment',
        data: this.postData,
      }).then((response) => {
        this.loading = false
        var arry=[]
        for (let i in Object.values(response.data.content)[0]) {
          arry.push(Object.values(response.data.content)[0][i])
        }
        this.$message({
          message: '上传成功',
          type: 'success'
        });
          this.$get_function(this.Data, Object.keys(response.data.content)[0])


      })
    },

    show_message() {
      this.$message({
        message: '最多上传' + this.limit.toString() + '个文件',
        type: 'warning'
      });
    },
 
    handlePictureCardPreview(file) {
      this.dialogImageUrl = [file.src];
      this.dialogVisible = true;
    },

  }
}
</script>

<style scoped>
.viewer-container {
  position: relative;
}

.viewer-container:hover .el-button {
  display: block;
}

.viewer-container .el-image {
  width: 148px;
  aspect-ratio: 1; 
  cursor: pointer;
}

.viewer-container .el-button {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
  border: none;
  padding: 6px;
  /* background-color: transparent; 
  color: red;
  font-size: 20px; */
}

.upload-demo {
  width: 148px;
}
</style>